import lazyWithRetry from 'tools/lazyWithRetry';

const ParticipationDashboardPage = lazyWithRetry(() => import(
	'../../pages/Participation/ParticipationDasboardPage'));

export default [
	{
		component: ParticipationDashboardPage,
		exact: true,
		path: '/participation',
	},
];